import { render, staticRenderFns } from "./SetupUserForm.vue?vue&type=template&id=046ff76b&scoped=true"
import script from "./SetupUserForm.vue?vue&type=script&lang=js"
export * from "./SetupUserForm.vue?vue&type=script&lang=js"
import style0 from "./SetupUserForm.vue?vue&type=style&index=0&id=046ff76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ff76b",
  null
  
)

export default component.exports